/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  style.ts
 */

import { type Theme, css } from '@emotion/react'

export const homepageNavbar = css`
  display: flex;
  justify-content: space-between;
  padding: 24px;
`

export const HomepageNavSection = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 0;
`

export const menuBtn = ({ colors }: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  background: 0;
  border: 1px solid ${colors?.background ?? '#ebeae6'};
  border-radius: 50%;
`
